export default "__VITE_ASSET__1FTe3Beb__"